import { Generic } from './Text';
export function isText(node) {
    return node !== null && typeof node === 'object' && node instanceof Generic;
}
export default isText;    //# sourceMappingURL=isText.js.map
